var UNICODE = {};

UNICODE.EN_DASH = String.fromCharCode(0x2013);
